import { render, staticRenderFns } from "./PollRating.vue?vue&type=template&id=b644f2d0&scoped=true&"
import script from "./PollRating.vue?vue&type=script&lang=js&"
export * from "./PollRating.vue?vue&type=script&lang=js&"
import style0 from "./PollRating.vue?vue&type=style&index=0&id=b644f2d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b644f2d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRating } from 'vuetify/lib/components/VRating';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VRating,VTooltip})
